import React, { useContext, useEffect, useState } from "react";
import { ContentZoneContext } from "cms/components/context/index";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { isArrayEmpty, isArrayNotEmpty } from "utils/empty-exists";
import { HeroSlide } from "cms/components/components/hero/display/hero-slide";
import { useImageLoader } from "cms/components/components/hero/display/use-image-loader";
import { Hero } from "cms/components/components/hero/display/hero";

const HeroComponentDisplay = () => {
    const { component } = useContext(ContentZoneContext);
    const { slides = [], image_position = "background" } = component || {};
    const hasContent = isArrayNotEmpty(slides);
    const total = slides?.length ?? 0;

    const { fetchImageData, preloadImageArray } = useImageLoader();

    const [index, setIndex] = useState(0);
    const [datas, setDatas] = useState([]);
    const [images, setImages] = useState(null);

    const buildSlidesData = async (slides) => {
        const datas = [];
        try {
            for (const slide of slides) {
                const { image } = slide || {};
                const { image: image_guid } = image || {};
                if (image_guid) {
                    const data = await fetchImageData(image_guid);
                    datas.push(data);
                }
            }
            const images = await preloadImageArray(datas);
            setDatas(datas);
            setImages(images);
        } catch (err) {
            console.error(err);
        }
        return images;
    };

    useEffect(() => {
        buildSlidesData(slides);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slides]);

    function moveIndex (increment) {
        let idx = index + increment;
        if (idx > slides.length - 1) {
            idx = 0;
        }
        if (idx < 0) {
            idx = slides.length - 1;
        }
        setIndex(idx);
    }

    if (isArrayEmpty(slides)) {
        return (
            <EmptyContentMessage
                hasContent={hasContent}
                component={component}
                message='No content to display. Click "Edit Content" to configure'
            />
        );
    } else if (slides.length === 1) {
        return (
            <div className="new-container">
                <Hero
                    slides={slides}
                    images={images}
                    imageDatas={datas}
                    key={index}
                    index={index}
                    total={total}
                    moveIndex={moveIndex}
                    image_position={image_position}
                />
            </div>
        );
    } else {
        return (
            <div className="new-container">
                <HeroSlide
                    slides={slides}
                    images={images}
                    key={index}
                    index={index}
                    total={total}
                    moveIndex={moveIndex}
                    image_position={image_position}
                />
            </div>
        );
    }
};

HeroComponentDisplay.displayName = "HeroComponentDisplay";
export { HeroComponentDisplay };
